<template>
  <el-drawer
    ref="drawer"
    :with-header="false"
    size="40%"
    append-to-body
    :visible.sync="display"
    direction="rtl"
    destroy-on-close
  >
    <div class="edit-form">
      <div class="edit-content">
        <union-json-editor
          ref="editor"
          :json="json"
          :editable="editable"
          height="100%"
          @error="e => error = e"
        />
      </div>
      <div
        v-if="editable"
        class="edit-footer"
      >
        <el-button
          type="primary"
          :loading="loading"
          @click="onCopy"
        >
          复制
        </el-button>
        <el-button
          v-if="editable"
          type="primary"
          :loading="loading"
          @click="onSave"
        >
          修 改
        </el-button>
        <el-button @click="close">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
// 封装JsonEditor为抽屉模式；
import JsonEditor from './JsonEditor';

export default {
  name: 'JsonDrawer',
  components: {
    'union-json-editor': JsonEditor,
  },
  props: {
    visible: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
    json: {
      type: [String, Number, Object, Array],
      default: '',
    },
    // promise
    fetchSave: { type: Function, default: null },
  },
  data() {
    return {
      error: null,
      loading: false,
    };
  },
  computed: {
    display: {
      get: function() {
        return this.visible;
      },
      set: function(v) {
        this.$emit('update:visible', v);
      },
    },
  },
  methods: {
    close() {
      this.$refs.drawer.closeDrawer();
    },

    onSave() {
      if (this.error) {
        return this.$message.error('当前json格式有误');
      }
      const value = this.$refs.editor.getValue();
      this.$emit('change', value);
      if (this.fetchSave) {
        this.loading = true;
        this.fetchSave(value)
          .then(() => {
            this.loading = false;
            this.close();
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.close();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.edit-form {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-flow: column nowrap;
  .edit-content {
    flex: 1;
    overflow-y: auto;
  }
  .edit-footer {
    flex-shrink: 1;
    padding-top: 16px;
    padding-left: 32px;
    height: 100px;
    box-sizing: border-box;
  }
}
</style>